export async function getUser(userManager) {
    const user = await userManager.getUser();
    return user;
}

export async function handleOAuthCallback(userManager) {
    try {
        await userManager.signinRedirectCallback();
        return true;
    } catch (e) {
        await userManager.clearStaleState();
        console.log(`error while handling oauth callback: ${e}`);
    }
}

export async function sendOAuthRequest(userManager) {
    return await userManager.signinRedirect();
}
